import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { SYSTEM_DATA_THEMES } from '../../../misc/constants';
import Box from '../../Box/Box';
import ButtonIcon from '../../ButtonIcon/ButtonIcon';
import Icon from '../../Icon/Icon';
import Typography from '../../Typography/Typography';

import './ModalPageHeader.css';

function ModalPageHeader({
  title,
  subHeadingContent,
  closeHandler,
  className,
  dataTheme,
  dataTestId,
}) {
  const modalPageBackgroundClasses = classnames(
    'ModalPageHeader-background',
    className
  );

  return (
    <header
      className={modalPageBackgroundClasses}
      data-theme={dataTheme}
      data-testid={dataTestId}
    >
      <Box tag='div' className='ModalPageHeader'>
        <Box tag='div' className='ModalPageHeader-textContainer'>
          <Typography kind='h1' className='ModalPageHeader-title'>
            {title}
          </Typography>
          <Box tag='div' className='ModalPageHeader-subHeadingContent'>
            {subHeadingContent}
          </Box>
        </Box>
        <ButtonIcon
          size='large'
          kind='ghost'
          className='ModalPageHeader-closeButton'
          icon={<Icon kind='Close' />}
          onClick={() => {
            closeHandler();
          }}
        />
      </Box>
    </header>
  );
}

ModalPageHeader.propTypes = {
  title: PropTypes.string,
  subHeadingContent: PropTypes.node,
  closeHandler: PropTypes.func,
  className: PropTypes.string,
  dataTheme: PropTypes.oneOf(Object.values(SYSTEM_DATA_THEMES)),
  dataTestId: PropTypes.string,
};

ModalPageHeader.defaultProps = {
  title: null,
  subHeadingContent: null,
  closeHandler: () => window.history.back(),
  className: null,
  dataTheme: SYSTEM_DATA_THEMES.DARK,
  dataTestId: null,
};

export default ModalPageHeader;
